import icFileDown from "assets/images/ic-file-down-02.svg";
import Button from "components/commons/button";
import DeleteModal from "components/commons/delete-modal";
import ErrorMessage from "components/commons/error-message";
import FormModal from "components/commons/form-modal";
import Input from "components/commons/input";
import Table from "components/commons/table";
import Toast from "components/commons/toast";
import ViewList from "components/commons/view-list";
import { TABLE_HAPPINESS_INDEX_IMPORT_DATA } from "configs/hr-metrics/configTableHappinessIndexList";
import { ImportHappinessIndexContainer } from "containers/hr-metrics/happiness-index/create/ImportHappinessIndexContainer";

export const ImportData = ({
    dataList,
    isLoading,
    isDeleting,
    isUpdating,
    isLoadingSubmit,
    query,
    toast,
    modal,
    form,
    errorForm,
    isFormValid,
    onChangeQuery,
    setShowModal,
    clearToast,
    onChangeForm,
    onHideImport,
    onClickItemHandler,
    onDelete,
    onSubmitEdit,
    onSubmit,
}) => {

    return (
        <>
            <div className={"flex items-center space-x-7 px-6 py-4"}>
                <div className={"flex gap-3"}>
                    <div className={"flex items-center gap-2"}>
                        <ViewList
                            show={modal?.limit}
                            onShow={() => setShowModal({limit: true})}
                            onClose={() => setShowModal({limit: false})}
                            value={query?.limit}
                            onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                        />
                    </div>
                    <Button title="Import" icon={icFileDown} type="outline" onClick={() => setShowModal({import: true})}/>
                </div>
            </div>
            <Table
                className="my-3"
                name={TABLE_HAPPINESS_INDEX_IMPORT_DATA.name}
                columns={TABLE_HAPPINESS_INDEX_IMPORT_DATA.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickSort={(val) => onChangeQuery(val)}
                loading={isLoading}
                onClickItem={(val) => onClickItemHandler(val)}
            />
            <div className={"flex justify-end px-6 py-4"}>
                <Button className="px-8" title="Submit" loading={isLoadingSubmit} onClick={onSubmit}/>
            </div>

            <FormModal
                show={modal?.edit}
                onHide={() => setShowModal({edit: false})}
                title={'Edit Happiness Index'}
                onSubmitForm={onSubmitEdit}
                isLoading={isUpdating}
                isDisabled={!isFormValid}
            >
                <div className={"px-8 py-6 mb-2 space-y-6"}>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Period'}</div>
                        <Input
                            className="flex-1"
                            name="period"
                            value={form?.period}
                            disabled
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Department'}</div>
                        <Input
                            className="flex-1"
                            name="department_name"
                            placeholder="Isi nama department"
                            maxLength={100}
                            value={form?.department_name}
                            onChange={onChangeForm}
                        />
                    </div>
                    <div className="flex items-center gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'Total Responden'}</div>
                        <Input
                            className="flex-1"
                            name="total_respondents"
                            type="number"
                            placeholder="Isi total responden"
                            value={form?.total_respondents}
                            onChange={onChangeForm}
                        />
                    </div>
                    <div className="flex gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'HI Company'}</div>
                        <div className="flex-1">
                            <Input
                                className="flex-1"
                                name="company_happiness_index"
                                type='float'
                                placeholder="Isi HI company"
                                addonAfter="%"
                                maxLength={5}
                                value={form?.company_happiness_index}
                                onChange={onChangeForm}
                            />
                            <ErrorMessage className="mt-2" message={errorForm?.company_happiness_index}/>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'HI People & Culture'}</div>
                        <div className="flex-1">
                            <Input
                                className="flex-1"
                                name="pnc_happiness_index"
                                type='float'
                                placeholder="Isi HI People & Culture"
                                addonAfter="%"
                                maxLength={5}
                                value={form?.pnc_happiness_index}
                                onChange={onChangeForm}
                            />
                            <ErrorMessage className="mt-2" message={errorForm?.pnc_happiness_index}/>
                        </div>
                    </div>
                    <div className="flex gap-3">
                        <div className="font-medium w-1/3 text-neutral-70 text-md">{'HI Finance'}</div>
                        <div className="flex-1">
                            <Input
                                className="flex-1"
                                name="finance_happiness_index"
                                type='float'
                                placeholder="Isi HI company"
                                addonAfter="%"
                                maxLength={5}
                                value={form?.finance_happiness_index}
                                onChange={onChangeForm}
                            />
                            <ErrorMessage className="mt-2" message={errorForm?.finance_happiness_index}/>
                        </div>
                    </div>
                </div>
            </FormModal>

            <DeleteModal
                show={modal?.delete}
                onHide={() => setShowModal({delete: false})}
                onDelete={onDelete}
                isLoading={isDeleting}
                text="Apakah anda yakin ingin menghapus data happiness index ini ?"
            />

            <Toast
                show={toast?.isShowToast}
                message={toast?.message}
                onClose={() => clearToast()}
            />

            <ImportHappinessIndexContainer show={modal?.import} onHide={onHideImport}/>
        </>
    )
}
